/**
 * Currency formatting utilities for the application
 */

/**
 * Format amount in Saudi Riyal (SAR) currency with English numerals
 * @param amount - The amount to format
 * @param locale - The locale to use for formatting (default: 'en-US' for English numerals)
 * @returns Formatted currency string
 */
export const formatSAR = (amount: number, locale: string = 'en-US'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'SAR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Format amount as a number with thousands separator using English numerals
 * @param amount - The amount to format
 * @param locale - The locale to use for formatting (default: 'en-US' for English numerals)
 * @returns Formatted number string
 */
export const formatNumber = (amount: number, locale: string = 'en-US'): string => {
  return new Intl.NumberFormat(locale).format(amount);
};

/**
 * Format percentage value using English numerals
 * @param value - The percentage value (0-100)
 * @param locale - The locale to use for formatting (default: 'en-US' for English numerals)
 * @returns Formatted percentage string
 */
export const formatPercentage = (value: number, locale: string = 'en-US'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100);
};
